import { Grid, Grow, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import Product from "./Product/Product";
import Form from "./Form/Form";
import useStyles from './styles'

const Products = () => {
    const classes = useStyles()
    const retailer = JSON.parse(localStorage.getItem('retailer'))
    const products = useSelector( state => state.products)

    return ( 
        <Grow in>
            <Grid container spacing={3} alignItems='stretch'>
                <Grid item xs={12} sm={8}>
                    <Grid container alignItems='center' spacing={3}> 
                        {
                            products.map( product => (
                                <Grid key={product._id} item xs={6} sm={4}>
                                    <Product product={product} />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
                { retailer?.user?._id ? (
                    <Grid item xs={12} sm={4}>  
                        <Form />
                    </Grid>
                ) : (
                    <div className={classes.welcome}>
                    <Typography component={Link} to='/auth' color='primary' variant='subtitle2'>Sign in to manage products</Typography>
                    </div>
                ) }
            </Grid>
        </Grow>
     );
}
 
export default Products;